module.exports = "<electra-map [ngClass]=\"menuClass\"></electra-map>\n<electra-menu-wrapper [ngClass]=\"menuClass + ' ' + menuState\"></electra-menu-wrapper>\n<electra-header-wrapper></electra-header-wrapper>\n<electra-splash></electra-splash>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/electraDesktop/electraDesktop.component.html
// module id = 422
// module chunks = 1